import { http } from '../../config/axios'
import { UserCredentials } from '../../interface/UserCredentials'

export interface AuthenticationResponse {
  // token retornado quando a autenticação é concluída
  token?: string
  // true quando o usuário possui duplo fator e precisa informar o código
  duploFator?: boolean
}

export default function postLogin(postLoginForm: UserCredentials): Promise<AuthenticationResponse> {
  return http
    .post('api/gatewaybiro/authentication', postLoginForm, {
      headers: {
          'originLogin': 'web'
      }
  })
    .then((res) => {
      return res.data as AuthenticationResponse
    })
    .catch((error) => {
      console.error('Erro ao fazer Login', error)
      throw Error(error.response.data)
    })
}
